<template lang="pug">
  .root
    component-header-login
    div(class="container-flex")
      div(class="content-info")
        <h3>利用規約</h3>
        div(class="term-content")
          <div class="default" v-html="text"></div>

    component-footer-index
</template>

<style src="./Index.scss" lang="scss">
</style>

<script>

import { getUserule } from '@/api/system'

export default {
  name: "TermsIndex",
  components: {
  },
  data() {
    return {
      text: '',
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {
    await this.init();
  },
  updated() {},
  destroyed() {},
  methods: {
    async init() {
      const data = await getUserule();
      this.text = data.terms_of_use.content.describe;
    },
  }
};
</script>
